/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import config from "../../coreFIles/config";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Tab,
  Nav,
  Accordion,
  Modal,
} from "react-bootstrap";
import Chart from "react-apexcharts";
import Certhik from "../../../src/component/Mrmintnew/images/partner/certhik.png";
import { Zoom, Slide } from "react-reveal";
import Header from "./directives/header";
import Footer from "./directives/footer";
import Partnerslider from "./Partnerslider";
import Channelpartnerslider from "./Channelpartnerslider";
import Inthenewsslider from "./Inthenewsslider";
import Gallery from "./Gallery";
import GlobalAwards from "./images/global_award.webp";
import Rightellipse from "./images/rightellipse.svg";
import Mrmintnft from "./images/ourproduct/mrmintnft.webp";
import Stepmint from "./images/ourproduct/stepmint.webp";
import Mintforce from "./images/ourproduct/mintforce.webp";
import Exchange from "./images/ourproduct/exchange.webp";
import Cricketcard from "./images/ourproduct/sprtmint.png";
import Sportiverse from "./images/ourproduct/sportiverse.webp";
import Bottomelllipse from "./images/bottomelllipse.svg";
import Rightyellow from "./images/rightyellow.png";
import Leftpink from "./images/leftpink.png";
import Piechart from "./images/piechart.webp";
import CoinImg from "./images/coinnew.webp";
import FatestGrowth from "./images/fastestGrowth.png";
import Listedblock from "./images/listedblock.png";
import Driven from "./images/driven.png";
import Dependable from "./images/dependable.png";
import Usersetting from "./images/users.png";

import Line from "./images/line.png";
import "react-accessible-accordion/dist/fancy-example.css";
import "./css/style.css";
import "./css/responsive.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import axios from "axios";
import Roadmap from "./Roadmap";
import Events from "./Gallery/events";
import { Link } from "react-router-dom";
import UpcomingEvent from "./Gallery/UpcomingEvent";
import { Helmet } from "react-helmet";
import { getevent } from "../../Action/user.action";
// import required modules
// import { Autoplay} from 'swiper/modules';asdf

const Home = () => {
  const [livePrice, setLivePrice] = useState(0);
  const [getEvent, setgetEvent] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    geteventSection();
    // setTimeout(() => {
    handleShow()
    // }, 1000);
  }, []);

  console.log("livePrice", livePrice);

  // url: `https://api.coinstore.com/api/v1/market/trade/MNTUSDT?size=1`,

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        await axios({
          method: "get",
          url: process.env.REACT_APP_COINMARKETCAPAPI,
        }).then((response) => {

          setLivePrice(response?.data);
        });
      } catch (error) {
      }
    };

    // Fetch price on load
    fetchPrice();

    // Set interval to fetch price every 1 minute (60000ms)
    const intervalId = setInterval(fetchPrice, 60000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Add the 'my-custom-class' to the body element
    document.body.classList.add("newtheme");
    // Clean up by removing the class when component unmounts
    return () => {
      document.body.classList.remove("newtheme");
    };
  }, []);

  const currentUrl = window.location.href;

  // ====================
  const geteventSection = async () => {
    try {
      let res = await getevent();

      if (res.success) {
        setgetEvent(res.data);
      }
    } catch (error) {
      console.log(error);

    }
  };

  return (
    <>
      <Helmet>
        <link rel="canonical" href={currentUrl} />
      </Helmet>
      <main className="home2">
        <Header />
        <section id="action1" className="p-0">
          <section className="hero-banner pt-4 pb-5 position-relative">
            <div className="social-icon mb-3 text-center">
              <p className="mb-3">Follow Us</p>
              <ul>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href=" https://www.instagram.com/officialmrmint/"
                  >
                    <img src="images/instagram.png" alt="instagram" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/officialmrmint/"
                  >
                    <img src="images/facebook.png" alt="facebook" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://twitter.com/MrMint_Official"
                  >
                    <img src="images/twiiter.png" alt="twitter" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/mr-mint/"
                    rel="noreferrer"
                  >
                    <img src="images/linkedin.png" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.reddit.com/r/MrMint_Official/"
                  >
                    <img src="images/reddit.png" alt="reddit" />
                  </a>
                </li>
              </ul>
            </div>
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={8} className="">
                  <Row className="justify-content-center">
                    <Col lg={12} className="text-center">
                      <div className="coin_ellipse position-relative mb-3">
                        <Zoom>
                          <img
                            src={CoinImg}
                            alt="Mr Mint Web3 Coin"
                            loading="lazy"
                          />
                        </Zoom>
                        <div className="priceBox px-4">
                          <div className="content">
                            <a
                              target="_blank"
                              href="https://mrmint.exchange/"
                              rel="noreferrer"
                            >
                              {" "}
                              <p>Live Price</p>
                              <h5>${livePrice ? livePrice?.data[0]?.price?.toFixed(5) : "0"}</h5>
                            </a>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12} className="text-center">
                      <Slide left>
                        <h1 className="mb-3">
                          Your Digital Sandbox in the Web 3.0 Cosmos
                        </h1>
                      </Slide>
                      <Slide right>
                        <h3 className="text-span-1 mb-4">
                          Explore, Create, and Transact!
                        </h3>
                      </Slide>
                      <Slide top>
                        <div>
                          <p className="mb-2">
                            Mr Mint leverages Web3 technology, ushering in a new
                            era of interaction
                          </p>
                        </div>
                      </Slide>

                      <br />
                      <Slide bottom>
                        <div className="">
                          <a
                            target="_blank"
                            href="images/mnt_litepaper.pdf"
                            className="me-3"
                          >
                            <button className="btn btn-primary btn-round download_litepaper">
                              Litepaper
                            </button>
                          </a>

                          <a
                            target="_blank"
                            href="images/WhitepaperUpdated.pdf"
                          >
                            <button className="btn btn-primary btn-round download_litepaper">
                              Whitepaper
                            </button>
                          </a>
                        </div>

                        <div className="mt-3">
                          <p>Smart Contract Audit By
                            {/* <img src={Certhik} alt="Certhik" className="img-fluid ms-2" width={120} /> */}
                            <a href="https://skynet.certik.com/projects/mr-mint?utm_source=CoinGecko&utm_campaign=AuditByCertiKLink"
                              target="_blank"
                            >
                              <img src={Certhik} alt="Certhik" className="img-fluid ms-2" width={120} />
                            </a>
                          </p>
                        </div>
                      </Slide>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="partner partner_bg py-3">
            <Container fluid className="px-0">
              <Partnerslider />
            </Container>
          </section>
          <section className="Overview card-style position-relative">
            <div className="shape">
              <img src={Leftpink} className="leftpink" />
            </div>
            <Container>
              <Card className="p-5 position-relative overflow-hidden">
                <div>
                  <img
                    src={Rightellipse}
                    className="rightellipse position-absolute start-0 top-0"
                  />
                  <img
                    src={Bottomelllipse}
                    className="bottomelllipse position-absolute bottom-0"
                  />
                </div>
                <Row className="justify-content-center align-items-center">
                  <Col lg={6} className="">
                    <Slide left>
                      <div className="overviewContent">
                        <h2>Overview</h2>
                        <p className="light-grey">
                          Mr Mint believes in instrumenting and prospecting the
                          world of Web 3.0 so that we can prosper in this
                          Digital Universe. In this Web 3.0 era, Mr Mint is
                          leading the charge, guiding the people towards a
                          decentralized future where possibilities are truly
                          limitless.{" "}
                        </p>
                        <div>
                          <ul>
                            <li className="mt-3">
                              <div className="d-flex align-items-center light-grey">
                                <span className="circleIcon gradient-box me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <g clipPath="url(#clip0_361_419)">
                                      <path
                                        d="M2.82253 1.6571H1.82617C0.995586 1.6571 0.322266 2.33043 0.322266 3.16101V5.66128"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M21.6775 5.66109V3.16083C21.6775 2.33024 21.0042 1.65692 20.1736 1.65692H4.32617"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M17.6661 5.66113H0.322266V8.33057"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M21.6777 6.99583V5.66113H19.1699"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M19.6756 4.32639C20.0442 4.32639 20.343 4.02761 20.343 3.65905C20.343 3.29048 20.0442 2.9917 19.6756 2.9917C19.3071 2.9917 19.0083 3.29048 19.0083 3.65905C19.0083 4.02761 19.3071 4.32639 19.6756 4.32639Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M17.0062 4.32639C17.3748 4.32639 17.6736 4.02761 17.6736 3.65905C17.6736 3.29048 17.3748 2.9917 17.0062 2.9917C16.6376 2.9917 16.3389 3.29048 16.3389 3.65905C16.3389 4.02761 16.6376 4.32639 17.0062 4.32639Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M14.3368 4.32639C14.7053 4.32639 15.0041 4.02761 15.0041 3.65905C15.0041 3.29048 14.7053 2.9917 14.3368 2.9917C13.9682 2.9917 13.6694 3.29048 13.6694 3.65905C13.6694 4.02761 13.9682 4.32639 14.3368 4.32639Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M6.67378 4.32644H1.97949C1.80152 4.32644 1.65723 4.18215 1.65723 4.00417V3.31396C1.65723 3.13599 1.80152 2.9917 1.97949 2.9917H6.67383C6.8518 2.9917 6.99609 3.13599 6.99609 3.31396V4.00413C6.99605 4.18215 6.8518 4.32644 6.67378 4.32644Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.32617 6.99579H15.6713"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <circle
                                        cx="2.9917"
                                        cy="6.99579"
                                        r="0.322266"
                                        fill="white"
                                      />
                                      <circle
                                        cx="1.65723"
                                        cy="6.99579"
                                        r="0.322266"
                                        fill="white"
                                      />
                                      <path
                                        d="M5.83034 20.343H20.1738C21.0044 20.343 21.6777 19.6697 21.6777 18.8391V6.99579H17.8961C17.7536 6.99579 17.617 7.05238 17.5163 7.1531L16.4962 8.17318C16.3955 8.27389 16.2588 8.33048 16.1164 8.33048H0.322266V18.839C0.322266 19.6696 0.995586 20.3429 1.82617 20.3429H4.32644"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M9.99909 13.6694H8.99805V11.6674H9.99909C10.5519 11.6674 11.0001 12.1155 11.0001 12.6684C11.0001 13.2213 10.552 13.6694 9.99909 13.6694Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M9.99909 15.6715H8.99805V13.6694H9.99909C10.5519 13.6694 11.0001 14.1176 11.0001 14.6705C11.0001 15.2233 10.552 15.6715 9.99909 15.6715Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M5.66113 13.6694V11.6674H7.66322"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M7.66322 15.6715H5.66113V13.6694H6.66218"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M2.32422 11.6674V15.6715L3.32526 14.6705L4.3263 15.6715V11.6674"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M13.002 12.6684C13.002 12.1155 13.4501 11.6674 14.003 11.6674C14.5559 11.6674 15.004 12.1155 15.004 12.6684C15.004 13.2213 14.5559 13.6694 14.003 13.6694C14.5559 13.6694 15.004 14.1176 15.004 14.6705C15.004 15.2234 14.5559 15.6715 14.003 15.6715C13.4501 15.6715 13.002 15.2234 13.002 14.6705"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <circle
                                        cx="16.3389"
                                        cy="15.6715"
                                        r="0.322266"
                                        fill="white"
                                      />
                                      <path
                                        d="M18.6749 15.6715C18.122 15.6715 17.6738 15.2234 17.6738 14.6705V12.6684C17.6738 12.1156 18.122 11.6674 18.6749 11.6674C19.2277 11.6674 19.6759 12.1155 19.6759 12.6684V14.6705C19.6759 15.2233 19.2277 15.6715 18.6749 15.6715Z"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M19.6358 12.3879L17.7134 14.951"
                                        stroke="white"
                                        strokeWidth="0.703125"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_361_419">
                                        <rect
                                          width="22"
                                          height="22"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                Empowering you in Web 3.0 World
                              </div>
                            </li>
                            <li className="mt-3">
                              <div className="d-flex align-items-center light-grey">
                                <span className="circleIcon gradient-box me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <g clipPath="url(#clip0_361_452)">
                                      <path
                                        d="M21.3212 8.1854C19.4718 7.81171 17.5981 8.02135 15.7526 8.80884C15.5969 8.87527 15.5191 9.0508 15.5745 9.21072L15.7767 9.79463C14.9462 9.79489 14.2562 9.57734 13.5322 9.34814C13.312 9.2784 13.0842 9.20634 12.8502 9.13966C11.7613 8.82968 10.6638 9.09669 9.8391 9.87219L9.73748 9.96771C8.32884 10.2856 7.35632 10.2654 6.19359 9.8791L6.42506 9.21072C6.48045 9.0508 6.40268 8.87527 6.247 8.80884C4.40145 8.02139 2.52784 7.81162 0.678379 8.1854C0.528031 8.21578 0.419922 8.34791 0.419922 8.50131V16.4969C0.419922 16.6749 0.564168 16.8191 0.742188 16.8191H3.56077C3.69809 16.8191 3.82034 16.7321 3.86529 16.6023L3.992 16.2364C5.06699 16.6408 5.89573 17.503 6.35812 17.9844C6.40457 18.0328 6.44762 18.0776 6.4872 18.1181L9.80679 21.5197C10.0127 21.7306 10.2902 21.8477 10.5883 21.8496C10.5908 21.8496 10.5931 21.8496 10.5954 21.8496C10.8953 21.8496 11.1763 21.7336 11.3874 21.5225C11.5201 21.3898 11.6122 21.2318 11.664 21.0639C12.1571 21.3395 12.7933 21.268 13.212 20.8494C13.4297 20.6317 13.5535 20.3552 13.5835 20.0706C13.6977 20.1028 13.8172 20.1195 13.9395 20.1195C14.2861 20.1195 14.6113 19.9852 14.8551 19.7414C15.089 19.5075 15.2145 19.2057 15.2317 18.8989C15.6449 18.9845 16.0922 18.8674 16.4123 18.5474C16.8847 18.075 16.9144 17.3369 16.5003 16.8165C16.6118 16.7945 16.7229 16.7614 16.8322 16.7168C17.1635 16.5816 17.4692 16.4279 17.7649 16.2794C17.8395 16.2419 17.9122 16.2055 17.9845 16.1696L18.1343 16.6023C18.1793 16.7321 18.3015 16.8191 18.4389 16.8191H21.2574C21.4355 16.8191 21.5797 16.6749 21.5797 16.4969V8.50131C21.5797 8.34791 21.4716 8.21578 21.3212 8.1854ZM3.33136 16.1746H1.0645V8.76909C2.60755 8.50647 4.1698 8.68075 5.71625 9.28786L3.33136 16.1746ZM15.9565 18.0916C15.7028 18.3452 15.2902 18.3452 15.0367 18.0916L13.0088 16.0182C12.8846 15.8908 12.6805 15.8883 12.5531 16.0126C12.4257 16.1369 12.4233 16.341 12.5476 16.4683L14.3967 18.3631C14.3971 18.3635 14.3974 18.3638 14.3978 18.3641C14.3984 18.3647 14.3989 18.3653 14.3994 18.3659C14.653 18.6194 14.653 19.0321 14.3994 19.2856C14.1458 19.5392 13.7331 19.5392 13.4797 19.2857L11.3657 17.1261C11.2413 16.9987 11.0373 16.9962 10.91 17.1206C10.7826 17.2449 10.7802 17.4489 10.9045 17.5763L12.7536 19.471C12.754 19.4714 12.7545 19.4718 12.755 19.4723C12.7554 19.4727 12.7559 19.4733 12.7563 19.4738V19.4738C12.8785 19.5959 12.9457 19.7592 12.9457 19.9337C12.9457 20.1082 12.8785 20.2715 12.7564 20.3935C12.5027 20.6471 12.0901 20.647 11.8366 20.3936L9.54124 18.0527C9.41689 17.9253 9.21283 17.9228 9.08556 18.0471C8.95816 18.1714 8.95571 18.3754 9.08002 18.5028L10.9291 20.3975C10.9295 20.3979 10.93 20.3983 10.9305 20.3988C10.9309 20.3993 10.9314 20.3998 10.9318 20.4003C11.1155 20.584 11.1155 20.883 10.9319 21.0667C10.8419 21.1567 10.7219 21.2053 10.5925 21.2051C10.468 21.2043 10.3528 21.1561 10.2682 21.0695L6.94864 17.668C6.91018 17.6286 6.86833 17.585 6.82317 17.538C6.32142 17.0156 5.42161 16.0794 4.20319 15.6271L5.98279 10.4883C6.67729 10.7194 7.31877 10.8328 8.00455 10.8328C8.28613 10.8328 8.57573 10.8129 8.87896 10.775L8.1332 11.4762C7.77647 11.8117 7.58793 12.2478 7.58793 12.7375V15.9756C7.58793 16.1537 7.73217 16.2979 7.91019 16.2979C9.29907 16.2979 10.7357 15.4195 10.7357 13.9493C10.7357 13.4419 11.1357 13.0792 11.4423 12.8285L14.9542 16.3383C15.1237 16.5076 15.318 16.6361 15.5263 16.722L15.9516 17.1666C16.2064 17.4332 16.2087 17.8395 15.9565 18.0916ZM17.4756 15.7034C17.1909 15.8464 16.8966 15.9943 16.5886 16.1199C16.1701 16.2908 15.7295 16.202 15.4097 15.8824L11.6909 12.1659C11.5701 12.0452 11.3761 12.0397 11.2486 12.1533C11.2144 12.1838 11.1676 12.2216 11.1134 12.2653C10.7561 12.5538 10.091 13.0906 10.091 13.9494C10.091 14.5553 9.73477 14.9483 9.43597 15.1714C9.10468 15.4186 8.67847 15.5808 8.23229 15.6341V12.7376C8.23229 12.4214 8.34422 12.1623 8.57457 11.9458L10.2806 10.3417C10.9361 9.72536 11.8083 9.51314 12.6737 9.75952C12.8987 9.82355 13.1218 9.89423 13.3376 9.96255C14.1386 10.2161 14.9653 10.4771 15.9983 10.4345L17.7719 15.5557C17.6718 15.6049 17.5727 15.6546 17.4756 15.7034ZM20.9351 16.1746H18.6683L16.2834 9.2879C17.8298 8.68075 19.392 8.50651 20.9351 8.76914V16.1746ZM3.50293 7.63106H7.86572V8.54308C7.86572 8.7211 8.00996 8.86534 8.18798 8.86534H13.8116C13.9896 8.86534 14.1339 8.7211 14.1339 8.54308V7.63106H18.4967C18.6747 7.63106 18.8189 7.48682 18.8189 7.3088V5.96134C18.8189 4.85911 18.1615 3.89485 17.1879 3.47246C17.5064 3.11956 17.7004 2.65451 17.7004 2.14525C17.7004 1.04529 16.7963 0.150421 15.6849 0.150421C14.5734 0.150421 13.6692 1.04529 13.6692 2.14525C13.6692 2.65494 13.8636 3.12038 14.1826 3.47341C13.5667 3.74269 13.0674 4.23426 12.7895 4.85133C12.6976 4.79766 12.6017 4.74962 12.5029 4.70674C12.8213 4.35384 13.0154 3.88879 13.0154 3.37957C13.0154 2.27957 12.1112 1.3847 10.9998 1.3847C9.88839 1.3847 8.98419 2.27957 8.98419 3.37957C8.98419 3.88883 9.17829 4.35388 9.49673 4.70678C9.3979 4.74967 9.30208 4.79771 9.21012 4.85137C8.93225 4.23426 8.43291 3.74274 7.81708 3.47345C8.13604 3.12046 8.33043 2.65503 8.33043 2.14533C8.33043 1.04537 7.42623 0.150507 6.31485 0.150507C5.20342 0.150507 4.29923 1.04537 4.29923 2.14533C4.29923 2.6546 4.49332 3.11969 4.81176 3.47255C3.83817 3.89493 3.18075 4.85919 3.18075 5.96143V7.30889C3.18066 7.48678 3.32495 7.63106 3.50293 7.63106ZM13.4893 8.22077H8.51029V7.19562C8.51029 6.2216 9.1834 5.38844 10.1251 5.17648C10.3898 5.30319 10.6866 5.3743 10.9999 5.3743C11.3131 5.3743 11.6099 5.30319 11.8746 5.17648C12.8163 5.38844 13.4894 6.2216 13.4894 7.19562V8.22077H13.4893ZM15.6849 0.794909C16.4409 0.794909 17.0559 1.40064 17.0559 2.1452C17.0559 2.88976 16.4409 3.49554 15.6849 3.49554C14.9288 3.49554 14.3138 2.88976 14.3138 2.1452C14.3138 1.40064 14.9288 0.794909 15.6849 0.794909ZM14.8104 3.94233C15.075 4.069 15.3717 4.14007 15.6849 4.14007C15.9981 4.14007 16.2949 4.06891 16.5596 3.9422C17.5013 4.15425 18.1744 4.98737 18.1744 5.96134V6.98653H14.1254C14.0742 6.31472 13.7788 5.70589 13.32 5.25635C13.5605 4.59648 14.1229 4.09792 14.8104 3.94233ZM10.9998 2.02919C11.7558 2.02919 12.3709 2.63496 12.3709 3.37952C12.3709 4.12409 11.7558 4.72977 10.9998 4.72977C10.2438 4.72977 9.62873 4.12404 9.62873 3.37948C9.62873 2.63492 10.2438 2.02919 10.9998 2.02919ZM6.31481 0.794909C7.0708 0.794909 7.68585 1.40064 7.68585 2.1452C7.68585 2.88976 7.0708 3.49554 6.31481 3.49554C5.55877 3.49554 4.94371 2.88976 4.94371 2.1452C4.94371 1.40064 5.55877 0.794909 6.31481 0.794909ZM3.8252 5.9613C3.8252 4.98733 4.4983 4.15421 5.44 3.94216C5.70473 4.06887 6.00152 4.14003 6.31481 4.14003C6.62796 4.14003 6.92462 4.06896 7.1893 3.94228C7.87672 4.09787 8.43922 4.5964 8.67968 5.25631C8.22086 5.70581 7.92545 6.31463 7.87427 6.98649H3.8252V5.9613Z"
                                        fill="white"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_361_452">
                                        <rect
                                          width="22"
                                          height="22"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                Opportunities to Explore, Engage & Earn More
                              </div>
                            </li>
                            <li className="mt-3">
                              <div className="d-flex align-items-center light-grey">
                                <span className="circleIcon gradient-box me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <g clipPath="url(#clip0_361_458)">
                                      <path
                                        d="M20.2191 5.66463C20.2078 5.07066 20.197 4.50955 20.197 3.96671C20.197 3.54143 19.8524 3.19665 19.427 3.19665C16.1337 3.19665 13.6263 2.2502 11.5363 0.218072C11.2373 -0.0727013 10.7615 -0.0725986 10.4626 0.218072C8.37277 2.2502 5.86577 3.19665 2.5727 3.19665C2.14743 3.19665 1.80265 3.54143 1.80265 3.96671C1.80265 4.50965 1.79197 5.07097 1.78057 5.66504C1.67502 11.1926 1.53046 18.7629 10.7472 21.9576C10.8289 21.9859 10.9142 22.0001 10.9994 22.0001C11.0846 22.0001 11.1699 21.9859 11.2515 21.9576C20.469 18.7628 20.3247 11.1923 20.2191 5.66463ZM10.9995 20.4129C3.0949 17.5414 3.21442 11.251 3.32048 5.69441C3.32684 5.36092 3.33301 5.0377 3.33732 4.72085C6.42165 4.59066 8.88809 3.65601 10.9995 1.81671C13.1111 3.65601 15.5779 4.59076 18.6625 4.72085C18.6668 5.0376 18.6729 5.36061 18.6793 5.69389C18.7853 11.2507 18.9047 17.5413 10.9995 20.4129Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M13.6514 8.32502L9.9347 12.0415L8.34869 10.4555C8.04796 10.1549 7.56036 10.1549 7.25973 10.4555C6.959 10.7563 6.959 11.2438 7.25973 11.5446L9.39022 13.6751C9.54053 13.8254 9.73767 13.9005 9.9347 13.9005C10.1317 13.9005 10.3289 13.8254 10.4792 13.6751L14.7403 9.41408C15.0411 9.11335 15.0411 8.62575 14.7404 8.32512C14.4397 8.02439 13.9521 8.02428 13.6514 8.32502Z"
                                        fill="white"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_361_458">
                                        <rect
                                          width="22"
                                          height="22"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                Reliable & Secure
                              </div>
                            </li>
                            <li className="mt-3">
                              <div className="d-flex align-items-center light-grey">
                                <span className="circleIcon gradient-box me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <path
                                      d="M20.9688 6.1875H18.9062C18.8151 6.1875 18.7276 6.22372 18.6632 6.28818C18.5987 6.35265 18.5625 6.44008 18.5625 6.53125V19.5938C18.5625 19.6849 18.5987 19.7724 18.6632 19.8368C18.7276 19.9013 18.8151 19.9375 18.9062 19.9375H20.9688C21.0599 19.9375 21.1474 19.9013 21.2118 19.8368C21.2763 19.7724 21.3125 19.6849 21.3125 19.5938V6.53125C21.3125 6.44008 21.2763 6.35265 21.2118 6.28818C21.1474 6.22372 21.0599 6.1875 20.9688 6.1875ZM20.625 19.25H19.25V6.875H20.625V19.25Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M17.5312 19.9375C17.6224 19.9375 17.7099 19.9013 17.7743 19.8368C17.8388 19.7724 17.875 19.6849 17.875 19.5938V9.28125C17.875 9.19008 17.8388 9.10265 17.7743 9.03818C17.7099 8.97372 17.6224 8.9375 17.5312 8.9375H15.4688C15.3776 8.9375 15.2901 8.97372 15.2257 9.03818C15.1612 9.10265 15.125 9.19008 15.125 9.28125V19.5938C15.125 19.6849 15.1612 19.7724 15.2257 19.8368C15.2901 19.9013 15.3776 19.9375 15.4688 19.9375H17.5312ZM15.8125 9.625H17.1875V19.25H15.8125V9.625Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M14.0938 19.9375C14.1849 19.9375 14.2724 19.9013 14.3368 19.8368C14.4013 19.7724 14.4375 19.6849 14.4375 19.5938V11.6875C14.4375 11.5963 14.4013 11.5089 14.3368 11.4444C14.2724 11.38 14.1849 11.3438 14.0938 11.3438H12.0312C11.9401 11.3438 11.8526 11.38 11.7882 11.4444C11.7237 11.5089 11.6875 11.5963 11.6875 11.6875V19.5938C11.6875 19.6849 11.7237 19.7724 11.7882 19.8368C11.8526 19.9013 11.9401 19.9375 12.0312 19.9375H14.0938ZM12.375 12.0312H13.75V19.25H12.375V12.0312Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M10.6562 19.9375C10.7474 19.9375 10.8349 19.9013 10.8993 19.8368C10.9638 19.7724 11 19.6849 11 19.5938V14.4375C11 14.3463 10.9638 14.2589 10.8993 14.1944C10.8349 14.13 10.7474 14.0938 10.6562 14.0938H8.59375C8.50258 14.0938 8.41515 14.13 8.35068 14.1944C8.28622 14.2589 8.25 14.3463 8.25 14.4375V19.5938C8.25 19.6849 8.28622 19.7724 8.35068 19.8368C8.41515 19.9013 8.50258 19.9375 8.59375 19.9375H10.6562ZM8.9375 14.7812H10.3125V19.25H8.9375V14.7812Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M7.21875 19.9375C7.30992 19.9375 7.39735 19.9013 7.46182 19.8368C7.52628 19.7724 7.5625 19.6849 7.5625 19.5938V15.8125C7.5625 15.7213 7.52628 15.6339 7.46182 15.5694C7.39735 15.505 7.30992 15.4688 7.21875 15.4688H5.15625C5.06508 15.4688 4.97765 15.505 4.91318 15.5694C4.84872 15.6339 4.8125 15.7213 4.8125 15.8125V19.5938C4.8125 19.6849 4.84872 19.7724 4.91318 19.8368C4.97765 19.9013 5.06508 19.9375 5.15625 19.9375H7.21875ZM5.5 16.1562H6.875V19.25H5.5V16.1562Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.78125 19.9375C3.87242 19.9375 3.95985 19.9013 4.02432 19.8368C4.08878 19.7724 4.125 19.6849 4.125 19.5938V17.5312C4.125 17.4401 4.08878 17.3526 4.02432 17.2882C3.95985 17.2237 3.87242 17.1875 3.78125 17.1875H1.71875C1.62758 17.1875 1.54015 17.2237 1.47568 17.2882C1.41122 17.3526 1.375 17.4401 1.375 17.5312V19.5938C1.375 19.6849 1.41122 19.7724 1.47568 19.8368C1.54015 19.9013 1.62758 19.9375 1.71875 19.9375H3.78125ZM2.0625 17.875H3.4375V19.25H2.0625V17.875Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M9.28125 6.1875H9.96875C10.0599 6.1875 10.1474 6.15128 10.2118 6.08682C10.2763 6.02235 10.3125 5.93492 10.3125 5.84375C10.3125 5.75258 10.2763 5.66515 10.2118 5.60068C10.1474 5.53622 10.0599 5.5 9.96875 5.5H9.625V5.15625C9.625 5.06508 9.58878 4.97765 9.52432 4.91318C9.45985 4.84872 9.37242 4.8125 9.28125 4.8125C9.19008 4.8125 9.10265 4.84872 9.03818 4.91318C8.97372 4.97765 8.9375 5.06508 8.9375 5.15625V5.55913C8.70825 5.64029 8.51506 5.79986 8.39205 6.00965C8.26905 6.21944 8.22414 6.46596 8.26527 6.70565C8.3064 6.94534 8.43091 7.16278 8.61682 7.31957C8.80272 7.47636 9.03806 7.5624 9.28125 7.5625C9.37242 7.5625 9.45985 7.59872 9.52432 7.66318C9.58878 7.72765 9.625 7.81508 9.625 7.90625C9.625 7.99742 9.58878 8.08485 9.52432 8.14932C9.45985 8.21378 9.37242 8.25 9.28125 8.25H8.59375C8.50258 8.25 8.41515 8.28622 8.35068 8.35068C8.28622 8.41515 8.25 8.50258 8.25 8.59375C8.25 8.68492 8.28622 8.77235 8.35068 8.83682C8.41515 8.90128 8.50258 8.9375 8.59375 8.9375H8.9375V9.28125C8.9375 9.37242 8.97372 9.45985 9.03818 9.52432C9.10265 9.58878 9.19008 9.625 9.28125 9.625C9.37242 9.625 9.45985 9.58878 9.52432 9.52432C9.58878 9.45985 9.625 9.37242 9.625 9.28125V8.87837C9.85425 8.79721 10.0474 8.63764 10.1704 8.42785C10.2935 8.21806 10.3384 7.97154 10.2972 7.73185C10.2561 7.49216 10.1316 7.27472 9.94568 7.11793C9.75978 6.96114 9.52444 6.8751 9.28125 6.875C9.19008 6.875 9.10265 6.83878 9.03818 6.77432C8.97372 6.70985 8.9375 6.62242 8.9375 6.53125C8.9375 6.44008 8.97372 6.35265 9.03818 6.28818C9.10265 6.22372 9.19008 6.1875 9.28125 6.1875Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M20.9688 2.0625H18.9063C18.8151 2.0625 18.7277 2.09872 18.6632 2.16318C18.5987 2.22765 18.5625 2.31508 18.5625 2.40625C18.5625 2.49742 18.5987 2.58485 18.6632 2.64932C18.7277 2.71378 18.8151 2.75 18.9063 2.75H20.1389L15.3264 7.5625H13.3918C13.4012 7.44911 13.4063 7.33451 13.4063 7.21875C13.4062 6.43541 13.1832 5.66827 12.7631 5.00707C12.3431 4.34586 11.7435 3.81792 11.0344 3.48499C10.3253 3.15207 9.53613 3.02792 8.7591 3.12708C7.98206 3.22624 7.24932 3.5446 6.64658 4.04493C6.04384 4.54526 5.59603 5.20686 5.35551 5.95236C5.11499 6.69786 5.09172 7.49644 5.28842 8.25468C5.48511 9.01292 5.89364 9.69948 6.46622 10.2341C7.0388 10.7686 7.75176 11.1291 8.5217 11.2734L7.0764 12.7188H4.46876C4.42362 12.7187 4.37892 12.7276 4.33721 12.7449C4.2955 12.7622 4.25761 12.7875 4.22568 12.8194L0.788185 16.2569C0.723717 16.3214 0.6875 16.4088 0.6875 16.5C0.6875 16.5912 0.723717 16.6786 0.788185 16.7431C0.852652 16.8075 0.940088 16.8438 1.03126 16.8438C1.12243 16.8438 1.20987 16.8075 1.27433 16.7431L4.61111 13.4062H7.21876C7.2639 13.4063 7.3086 13.3974 7.35031 13.3801C7.39202 13.3628 7.42991 13.3375 7.46183 13.3056L9.42649 11.3409C10.3153 11.3084 11.1698 10.9901 11.8633 10.4333C12.5567 9.87643 13.0521 9.11077 13.2758 8.25H15.4688C15.5139 8.25 15.5586 8.24111 15.6003 8.22384C15.642 8.20656 15.6799 8.18124 15.7118 8.14932L20.625 3.23615V4.46875C20.625 4.55992 20.6612 4.64735 20.7257 4.71182C20.7902 4.77628 20.8776 4.8125 20.9688 4.8125C21.0599 4.8125 21.1474 4.77628 21.2118 4.71182C21.2763 4.64735 21.3125 4.55992 21.3125 4.46875V2.40625C21.3125 2.31508 21.2763 2.22765 21.2118 2.16318C21.1474 2.09872 21.0599 2.0625 20.9688 2.0625ZM9.28126 10.6562C8.60139 10.6562 7.93678 10.4546 7.37149 10.0769C6.80619 9.69921 6.3656 9.16234 6.10542 8.53422C5.84525 7.9061 5.77717 7.21494 5.90981 6.54813C6.04245 5.88132 6.36984 5.26881 6.85058 4.78807C7.33132 4.30733 7.94383 3.97994 8.61064 3.8473C9.27745 3.71466 9.96861 3.78274 10.5967 4.04291C11.2249 4.30309 11.7617 4.74368 12.1394 5.30898C12.5172 5.87427 12.7188 6.53888 12.7188 7.21875C12.7177 8.13011 12.3552 9.00385 11.7108 9.64829C11.0664 10.2927 10.1926 10.6552 9.28126 10.6562Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>
                                Ensuring Sustainable Growth
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Slide>
                  </Col>
                  <Col lg={6} className="">
                    <Zoom>
                      <div className="overviewImage">
                        <img src={GlobalAwards} alt="Mr Mint Global Award" />
                      </div>
                    </Zoom>
                  </Col>
                </Row>
              </Card>
            </Container>
          </section>

          <section className="partner_bg">
            <Container>
              <div className="h2 mb-5">MRMINT Listed on</div>
              <Zoom>
                <Row className="mt-4 justify-content-between">
                  <Col lg={"auto"} className="text-center mt-3 mt-lg-0">
                    <a
                      href="https://coinmarketcap.com/currencies/mr-mint/"
                      target="_blank"
                    >
                      <div>
                        <img src="images/mnt_listed/4.png" className="mnt_listedImg" alt="Coinstore" />
                        <h4>Coinstore</h4>
                      </div>
                    </a>
                  </Col>
                  <Col lg={"auto"} className="text-center mt-3 mt-lg-0">
                    <a href='https://pancakeswap.finance/swap?inputCurrency=0x3e81Aa8d6813Ec9D7E6ddB4e523fb1601a0e86F3&outputCurrency=0x55d398326f99059fF775485246999027B3197955' target="_blank">
                      <div>
                        <img
                          src="images/mnt_listed/1.png"
                          alt="Pancakeswap"
                          className="mnt_listedImg"
                        />
                        <h4>Pancakeswap</h4>
                      </div>
                    </a>
                  </Col>

                  <Col lg={"auto"} className="text-center mt-3 mt-lg-0">
                    <a href="https://www.mexc.com/en-IN/exchange/MRMINT_USDT?_from=search" target="_blank">
                      <div>
                        <img
                          src="images/mexc-logo.png"
                          alt="Coinmarketcap"
                          className="mnt_listedImg"
                        />
                        <h4>MEXC</h4>
                      </div>
                    </a>
                  </Col>

                  <Col lg={"auto"} className="text-center mt-3 mt-lg-0">
                    <a href="https://www.coingecko.com/en/coins/mr-mint" target="_blank">
                      <div>
                        <img
                          src="images/mnt_listed/2.png"
                          alt="Coingeko"
                          className="mnt_listedImg"
                        />
                        <h4>Coingeko</h4>
                      </div>
                    </a>
                  </Col>


                  <Col lg={"auto"} className="text-center mt-3 mt-lg-0">
                    <a href="https://coinmarketcap.com/currencies/mr-mint/" target="_blank">
                      <div>
                        <img
                          src="images/mnt_listed/3.webp"
                          alt="Coinmarketcap"
                          className="mnt_listedImg"
                        />
                        <h4>Coinmarketcap</h4>
                      </div>
                    </a>
                  </Col>
                </Row>
              </Zoom>
            </Container>
          </section>

          <section className="Ecosystem" id="ecosystem">
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={8} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2">Ecosystem</div>
                      <p className="light-grey">
                        The ecosystem of Mr Mint revolves around creating a
                        seamless and efficient marketplace for digital assets,
                        particularly focusing on non-fungible tokens (NFTs).
                        Here's a breakdown of its components:{" "}
                      </p>
                    </div>
                  </Slide>
                </Col>
                <Col lg={12} className="">
                  <Zoom>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        1024: {
                          slidesPerView: 6,
                          spaceBetween: 15,
                        },
                      }}
                      modules={[]}
                      className="mySwiper"
                    >
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <img src={Usersetting} alt="icon" />
                            {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg> */}
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>
                                Reshaping Diverse Industries through Web3.0
                                Evolution
                              </h5>
                            </div>
                            <h3>01</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <img src={Listedblock} alt="icon" />
                            {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg> */}
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>Listed on Top CEX & DEX</h5>
                            </div>
                            <h3>02</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <img src={FatestGrowth} alt="icon" />
                            {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg> */}
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>Fastest Growing World Wide Community</h5>
                            </div>
                            <h3>03</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="61"
                              height="60"
                              viewBox="0 0 61 60"
                              fill="none"
                            >
                              <path
                                d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                                fill="#F9FFFF"
                              />
                              <path
                                d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                                fill="#F9FFFF"
                              />
                              <path
                                d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                                fill="#F9FFFF"
                              />
                              <path
                                d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                                fill="#F9FFFF"
                              />
                            </svg>
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>Backed by Industries Top Leaders</h5>
                              {/* <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p> */}
                            </div>
                            <h3>04</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <img src={Dependable} alt="icon" />
                            {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg> */}
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>
                                Unparalleled Growth with Trusted Investors
                              </h5>
                              {/* <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p> */}
                            </div>
                            <h3>05</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="card-style2">
                          <div className="gradient-circle-icon">
                            <img src={Driven} alt="icon" />
                            {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg> */}
                          </div>
                          <Card className="p-1 gradient-box">
                            <div className="innerCard">
                              <h5>Driven by expert tech crew</h5>
                              {/* <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p> */}
                            </div>
                            <h3>06</h3>
                          </Card>
                        </div>
                      </SwiperSlide>
                      {/* <SwiperSlide>
                      <div className="card-style2">
                        <div className="gradient-circle-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg>
                        </div>
                        <Card className="p-1 gradient-box">
                          <div className="innerCard">
                            <h5>Backed by Industries Top Leaders</h5>
                            <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p>
                          </div>
                          <h3>06</h3>
                        </Card>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="card-style2">
                        <div className="gradient-circle-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg>
                        </div>
                        <Card className="p-1 gradient-box">
                          <div className="innerCard">
                            <h5>Backed by Industries Top Leaders</h5>
                            <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p>
                          </div>
                          <h3>07</h3>
                        </Card>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="card-style2">
                        <div className="gradient-circle-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="61"
                            height="60"
                            viewBox="0 0 61 60"
                            fill="none"
                          >
                            <path
                              d="M34.9545 17.9091C34.9545 20.3636 32.9545 22.3636 30.5 22.3636C28.0454 22.3636 26.0454 20.3636 26.0454 17.9091C26.0454 15.4545 28.0454 13.4545 30.5 13.4545C32.9545 13.4545 34.9545 15.4545 34.9545 17.9091Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M55.591 5.63637C55.591 7.72728 53.9546 10 51.7728 10C49.591 10 47.9546 7.72728 47.9546 5.63637C47.9546 3.54546 49.6819 1.81819 51.7728 1.81819C53.9546 1.72728 55.591 3.45455 55.591 5.63637Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M5.40918 5.63636C5.40918 3.54545 7.13645 1.81818 9.22736 1.81818C11.3183 1.81818 13.0455 3.54545 13.0455 5.63636C13.0455 7.72727 11.4092 9.99999 9.22736 9.99999C7.04554 9.99999 5.40918 7.63636 5.40918 5.63636Z"
                              fill="#F9FFFF"
                            />
                            <path
                              d="M57.0455 24.5455C58.5001 24.5455 59.591 23.3636 59.591 22V14.5455C59.591 12.7273 58.1365 11.1818 56.2274 11.1818H47.3183C45.5001 11.1818 43.9546 12.6364 43.9546 14.5455V22.1818C43.9546 23.4545 45.0455 24.5455 46.3183 24.5455H46.8637V32.5455C46.7728 32.5455 46.6819 32.5455 46.591 32.6364C44.9546 33.4546 44.0455 34.7273 44.0455 36.0909C44.0455 37.4546 45.0455 38.6364 46.591 39.4546L36.2274 47.0909V37.5455C37.2274 38.1818 38.591 37.9091 39.3183 37.0909L43.6819 32C44.3183 31.2727 44.591 30.2727 44.4092 29.3636C44.2274 28.4545 43.6819 27.6364 42.8637 27.0909L37.0455 24C35.9546 23.4545 34.6819 23.0909 33.4092 23.0909H27.5001C26.2274 23.0909 24.9546 23.3636 23.8637 24L18.0455 27.0909C17.2274 27.5455 16.6819 28.3636 16.5001 29.3636C16.3183 30.2727 16.591 31.2727 17.2274 32L21.591 37.0909C22.4092 38 23.6819 38.1818 24.7728 37.5455V47.1818L14.4092 39.5455C15.9546 38.7273 16.9546 37.5455 16.9546 36.1818C16.9546 34.8182 16.0455 33.6364 14.4092 32.8182C14.3183 32.7273 14.1365 32.7273 14.0455 32.7273V24.5455H14.3183C15.7728 24.5455 16.8637 23.3636 16.8637 22V14.5455C16.8637 12.7273 15.4092 11.1818 13.5001 11.1818H4.77282C2.86373 11.2727 1.40918 12.7273 1.40918 14.5455V22.1818C1.40918 23.5455 2.50009 24.5455 3.77282 24.5455H4.31827V32.5455C4.22736 32.5455 4.13645 32.5455 4.04554 32.6364C2.31827 33.5455 1.40918 34.7273 1.40918 36.0909C1.40918 38.6364 4.86373 40.6364 9.22736 40.6364C10.4092 40.6364 11.5001 40.4545 12.5001 40.2727L23.4092 48.2727C21.5001 49.3636 20.5001 50.8182 20.5001 52.3636C20.5001 55.6364 24.9546 58.1818 30.591 58.1818C36.2274 58.1818 40.6819 55.6364 40.6819 52.3636C40.6819 50.7273 39.591 49.2727 37.7728 48.2727L48.4092 40.4545C48.5001 40.3636 48.591 40.3636 48.591 40.2727C49.591 40.5455 50.6819 40.7273 51.8637 40.7273C56.2274 40.7273 59.6819 38.7273 59.6819 36.1818C59.6819 34.8182 58.7728 33.6364 57.0455 32.7273C56.9546 32.6364 56.8637 32.6364 56.7728 32.6364V24.5455H57.0455ZM9.22736 38.9091C5.68191 38.9091 3.22736 37.4545 3.22736 36.1818C3.22736 35.6364 3.591 35.0909 4.31827 34.6364C4.50009 36.0909 5.68191 37.1818 7.22736 37.1818C8.04554 37.1818 8.68191 36.9091 9.22736 36.3636C9.77282 36.9091 10.5001 37.1818 11.2274 37.1818C12.6819 37.1818 13.9546 36.0909 14.1365 34.6364C14.8637 35.0909 15.2274 35.6364 15.2274 36.1818C15.2274 37.4545 12.7728 38.9091 9.22736 38.9091ZM30.2274 40.1818C30.2274 40 30.4092 39.7273 30.6819 39.7273C30.9546 39.7273 31.1365 39.9091 31.1365 40.1818V46.7273C30.9546 46.7273 30.7728 46.7273 30.591 46.7273H30.3183V40.1818H30.2274ZM36.2274 29.0909L38.6819 30.2727L36.2274 33.1818V29.0909ZM30.3183 25.2727L31.3183 28.2727L30.5001 29L29.6819 28.1818L30.3183 25.2727ZM22.3183 30.2727L24.7728 29.0909V33.1818L22.3183 30.2727ZM38.7728 52.4546C38.7728 54.3636 35.4092 56.4545 30.5001 56.4545C25.591 56.4545 22.2274 54.3636 22.2274 52.4546C22.2274 51.4546 23.2274 50.3636 24.8637 49.6364V52.3636C24.8637 53.8182 26.0455 55.0909 27.5001 55.0909C28.9546 55.0909 30.2274 53.9091 30.2274 52.3636V48.4545H30.5001H31.0455V52.4546C31.0455 53.1818 31.3183 53.8182 31.8637 54.3636C32.4092 54.8182 33.0455 55.0909 33.7728 55C35.0455 54.9091 36.1365 53.7273 36.1365 52.3636V49.6364C37.7728 50.3636 38.7728 51.4546 38.7728 52.4546ZM57.7728 36.0909C57.7728 37.3636 55.3183 38.8182 51.7728 38.8182C48.2274 38.8182 45.7728 37.3636 45.7728 36.0909C45.7728 35.5455 46.1365 35 46.8637 34.5455C47.0455 36 48.2274 37.0909 49.7728 37.0909C50.591 37.0909 51.2274 36.8182 51.7728 36.2727C52.3183 36.8182 53.0455 37.0909 53.7728 37.0909C55.2274 37.0909 56.5001 36 56.6819 34.5455C57.4092 35.0909 57.7728 35.6364 57.7728 36.0909Z"
                              fill="#F9FFFF"
                            />
                          </svg>
                        </div>
                        <Card className="p-1 gradient-box">
                          <div className="innerCard">
                            <h5>Backed by Industries Top Leaders</h5>
                            <p className="light-grey">
                              It is a long established fact that a reader will
                              be distracted by the readable content of a page
                              when looking at its layout.
                            </p>
                          </div>
                          <h3>08</h3>
                        </Card>
                      </div>
                    </SwiperSlide> */}
                    </Swiper>
                  </Zoom>
                </Col>
              </Row>
            </Container>
          </section>
          <section
            className="Ourproduct position-relative  pt-3"
            id="ourpeoduct"
          >
            <div className="shape">
              <img src={Leftpink} className="leftpink" />
              <img src={Rightyellow} className="rightyellow" />
            </div>
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={10} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2">Our Products</div>
                      <p className="light-grey">
                        At Mr Mint, we pride ourselves on crafting the finest
                        quality products that enhance your everyday experiences.
                        From refreshing mints to tantalizing gums, we've got
                        something to satisfy every taste bud and freshen every
                        breath. Here's a glimpse of our exquisite product line:{" "}
                      </p>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Zoom>
                <Row className="card-style3 justify-content-center">
                  <Col lg={6} className="mb-4">
                    <Card>
                      <a href="https://nft.mrmint.io/" target="_blank">
                        <img src={Mrmintnft} alt="Mint Force" />
                      </a>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Card>
                      <a href="https://nft.mrmint.io/nftmarketplace" target="_blank">
                        <img src='images/bnner.jpg' alt='Mr Mint NFT Marketplace' style={{ borderRadius: '24px' }}
                        />
                      </a>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Card>
                      <a href="https://stepmint.io/" target="_blank">
                        <img src={Stepmint} alt="Step Mint Web3" />
                      </a>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Card className="h-100">
                      <a href="https://sportsmint.io/" target="_blank">
                        <img src={Cricketcard} style={{ borderRadius: '24px' }} alt="Experience fantasy cricket and nft thrills" />
                      </a>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Card>
                      <img src={Exchange} alt="Mr Mint Exchange" />
                    </Card>
                  </Col>

                  <Col lg={6} className="mb-4">
                    <Card>
                      <a href="https://mrmintchain.io/" target="_blank">
                        <img
                          // src="images/ourproduct_img.jpg"
                          src="assets/images/mrmintchain.png"
                          alt="Mr Mint Blockchain!"
                        />
                      </a>
                    </Card>
                  </Col>

                  {/* <Col lg={6} className="mb-4">
                  <Card>
                    <img src={Mintforce} />
                  </Card>
                </Col> */}
                  {/* 
                <Col lg={6} className="mb-4">
                  <Card>
                    <img src={Cricketcard} />
                  </Card>
                </Col>
                <Col lg={6} className="mb-4">
                  <Card>
                    <img src={Exchange} />
                  </Card>
                </Col> */}
                </Row>
              </Zoom>
            </Container>
          </section>
          <section className="Roadmap roadmap_bg pt-3" id="roadmap">
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={10} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2">Roadmap</div>
                      <p className="light-grey">
                        A journey marked by innovation and progress, Mr Mint's
                        roadmap charts a course through Web 3.0 evolution with
                        milestones including product launches, cross-blockchain
                        development, and the establishment of a vibrant
                        community at the forefront of innovation.
                      </p>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Zoom>
                    <div className="tab_style1">
                      <Roadmap />
                    </div>
                  </Zoom>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="Tokenomics pt-2" id="tokenomics">
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={10} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2 mb-0">Tokenomics</div>

                      <div className="tab_style2 my-3">
                        <Button
                          variant="primary"
                          disabled
                          className="btn-round download_litepaper"
                        >
                          Token Name: Mr Mint
                        </Button>
                        <span className="mx-3">
                          <Button
                            variant="primary"
                            disabled
                            className="btn-round download_litepaper"
                          >
                            Ticker: MRMINT
                          </Button>
                        </span>
                        <Button
                          variant="primary"
                          disabled
                          className="btn-round download_litepaper"
                        >
                          Chain: BSC
                        </Button>
                      </div>
                      <p className="light-grey">
                        Our token distribution ensures a robust ecosystem, with
                        allocations for private and public sales, marketing,
                        liquidity staking, and support for research and
                        development, all aimed at fostering sustainable growth
                        and community engagement.
                      </p>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Row>
                <Col lg={5}>
                  <Zoom>
                    <Card className="piechart piechart_bg p-4">
                      <img src={Piechart} alt="Mr Mint Pie Chart!" />
                      {/* <Chart
                    type="pie"
                    series={[5, 15, 20, 10, 2, 1, 1, 12, 7, 4, 18, 1, 4]}
                    className="PieChart"
                    options={{
                      noData: { text: "Empty Data" },
                      labels: [
                        "Private Sale",
                        "Pre-sale",
                        "Public Sale",
                        "Marketing",
                        "Referral",
                        "R & D",
                        "Airdrop",
                        "Liquidity Staking",
                        "Ecosystem",
                        "Reserve",
                        "Team",
                        "Charity",
                        "Advisory",
                      ],
                    }}
                  ></Chart> */}
                    </Card>
                  </Zoom>
                </Col>
                <Col lg={7}>
                  {/* <Slide right> */}
                  <div className="text-center tokenomics_table">
                    <table className="table border border-dark" width="100%">
                      <thead>
                        <tr>
                          <th>DETAILS</th>
                          <th>%(Ptg.)</th>
                          <th>TOKEN QTY</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td> Private Sale </td>
                          <td>5% </td>
                          <td> 50,000,000 </td>
                        </tr>
                        <tr>
                          <td>Pre-sale </td>
                          <td>15% </td>
                          <td>150,000,000 </td>
                        </tr>
                        <tr>
                          <td>Public Sale </td>
                          <td>20% </td>
                          <td>200,000,000 </td>
                        </tr>
                        <tr>
                          <td>Marketing</td>
                          <td>10% </td>
                          <td>100,000,000</td>
                        </tr>
                        <tr>
                          <td>Referral</td>
                          <td>2% </td>
                          <td>20,000,000</td>
                        </tr>
                        <tr>
                          <td>R &amp; D </td>
                          <td>1% </td>
                          <td>10,000,000 </td>
                        </tr>
                        <tr>
                          <td>Airdrop </td>
                          <td>1% </td>
                          <td>10,000,000 </td>
                        </tr>
                        <tr>
                          <td>Liquidity Staking </td>
                          <td>12% </td>
                          <td>120,000,000 </td>
                        </tr>
                        <tr>
                          <td>Ecosystem</td>
                          <td>7% </td>
                          <td>70,000,000 </td>
                        </tr>
                        <tr>
                          <td>Reserve</td>
                          <td>4% </td>
                          <td>40,000,000 </td>
                        </tr>
                        <tr>
                          <td>Team</td>
                          <td>18% </td>
                          <td>180,000,000 </td>
                        </tr>
                        <tr>
                          <td>Charity</td>
                          <td>1% </td>
                          <td>10,000,000 </td>
                        </tr>
                        <tr>
                          <td>Advisory</td>
                          <td>4% </td>
                          <td>40,000,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* </Slide> */}
                </Col>
              </Row>
            </Container>
          </section>
          {/* <section className="ChannelPartners pt-0">
          <Container fluid>
            <Row className="justify-content-center align-items-center">
              <Col lg={10} className="text-center">
                <Slide top>
                  <div className="text-center mb-5">
                    <h3>Channel Partners </h3>
                  </div>
                </Slide>
              </Col>
            </Row>
            <Container fluid className="px-0">
              <Zoom>
                <Channelpartnerslider />
              </Zoom>
            </Container>
          </Container>
        </section> */}
          <section className="Inthenews pt-3" id="inthenews">
            <Container fluid>
              <Row className="justify-content-center align-items-center">
                <Col lg={10} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2">In the News </div>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Container fluid className="px-0">
                <Zoom>
                  <Inthenewsslider />
                </Zoom>
              </Container>
            </Container>
          </section>

          {/* <section className="Event event_bg" id="events">
            <Container>
              <Row className="justify-content-center align-items-center">
                <Col lg={10} className="text-center">
                  <Slide top>
                    <div className="text-center mb-4">
                      <div className="h2">Events</div>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Container fluid className="px-0">
                <Row>
                  <Col lg={12}>
                    <div className="tab_style2">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="events"
                      >
                        <Row>
                          <Col sm={12} className="mb-3 mb-sm-5">
                            <Nav
                              variant="pills"
                              className="justify-content-center"
                            >
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="events"
                                  className="custombtn"
                                >
                                  Events
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link
                                  eventKey="upcomingEvents"
                                  className="custombtn"
                                >
                                  Upcoming Events
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link eventKey="gallery">Gallery</Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                          <Col sm={12}>
                            <Tab.Content>
                              <Tab.Pane eventKey="upcomingEvents">
                                <Events getEvent={getEvent} />
                              </Tab.Pane>
                              <Tab.Pane eventKey="events">
                                <UpcomingEvent getEvent={getEvent} />
                              </Tab.Pane>
                              <Tab.Pane eventKey="gallery">
                                <Gallery getEvent={getEvent} />
                              </Tab.Pane>
                            </Tab.Content>
                          </Col>
                        </Row>
                      </Tab.Container>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Container>
          </section> */}

          <section className="faq" id="faq">
            <Container fluid>
              <Row className="justify-content-center align-items-center">
                <Col lg={8} className="text-center">
                  <Slide top>
                    <div className="text-center mb-5">
                      <div className="h2 mb-4">Frequently Asked Questions </div>
                      <p className="light-grey mb-0">
                        Below is a list frequently questions and answers from
                        partners
                      </p>
                      <p className="light-grey">
                        Please check this FAQ first before contacting Us.
                      </p>
                    </div>
                  </Slide>
                </Col>
              </Row>
              <Container>
                <Row>
                  <Col lg={12}>
                    <Slide left>
                      <div className="accordion_style1">
                        <Accordion defaultActiveKey="">
                          <Row>
                            <Col lg={6}>
                              <Accordion.Item eventKey="0" className="mb-3">
                                <Accordion.Header>
                                  What is Mr Mint ($MRMINT)?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    MRMINT is a BSC token designed to make
                                    investing in crypto mining super simple,
                                    even without any knowledge or expensive
                                    equipment. We collaborate with strategic
                                    mining partners in Australia, the United
                                    Kingdom, Iceland, and India who utilize 100%
                                    hydroelectric and solar power for mining
                                    $BTC and other cryptocurrencies.
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="1" className="mb-3">
                                <Accordion.Header>
                                  What is the Official Contract Address?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    The contract address is:{" "}
                                    <b>
                                      0x3e81Aa8d6813Ec9D7E6ddB4e523fb1601a0e86F3
                                    </b>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="2" className="mb-3">
                                <Accordion.Header>
                                  Who are the people behind Mr Mint? Where can I
                                  read about the team?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    The Team behind the Mr Mint Project comes
                                    with expertise in the domain of over a
                                    decade. They have been active investors,
                                    traders, miners, and also have a technical
                                    background that grew hand-in-hand with the
                                    growth of the domain.
                                  </p>
                                  <p>
                                    Keeping in line with the culture of crypto
                                    and blockchain, the team has chosen to be
                                    pseudonymous. The project's potential is
                                    backed by extensive research, experience,
                                    and learnings of the team. They envision the
                                    project shining in the light of its own
                                    progress, standing on its own merits. This
                                    allows Mr Mint to be its authentic self.
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="3" className="mb-3">
                                <Accordion.Header>
                                  Can I know more about the tokenomics of the
                                  $MRMINT token?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    Here are Mr Mint’s tokenomics in detail{" "}
                                    <a
                                      style={{ color: "#11c2ff" }}
                                      href="https://mrmint.io/#tokenomics"
                                    >
                                      https://mrmint.io/#tokenomics
                                    </a>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="4" className="mb-3">
                                <Accordion.Header>
                                  How do Mining Rewards Work?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    All of the mining rewards, i.e. the $BTC
                                    earned from mining is added to the liquidity
                                    and market cap of $MRMINT, or in other words,
                                    used to purchase $MRMINT tokens, some of which
                                    are immediately burned after purchase. This
                                    not only increases the price of $MRMINT but
                                    also decreases the supply gradually giving
                                    you an asset to hold.
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="5" className="mb-3">
                                <Accordion.Header>
                                  How do I purchase $MRMINT?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    To purchase $MRMINT, you need to have BNB.{" "}
                                    <br />
                                    If you’re looking for a step-by-step guide
                                    on how to buy $MRMINT Token, follow these:{" "}
                                    <br />
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://www.youtube.com/watch?v=uLExgGXE_Vw"
                                    >
                                      How to create a Metamask Wallet and buy
                                      BNB{" "}
                                    </a>{" "}
                                    <br />
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://www.youtube.com/watch?v=RcDDbU53SIY"
                                    >
                                      How to buy MRMINT
                                    </a>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="6" className="mb-3">
                                <Accordion.Header>
                                  I don't have a MetaMask Wallet. Can I still
                                  buy the Mr Mint token?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    To purchase $MRMINT, you can use a
                                    decentralized wallet like Trust Wallet or
                                    Metamask. If you’re looking for a
                                    step-by-step guide on how to create a
                                    MetaMask Wallet, follow this:{" "}
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://www.youtube.com/watch?v=uLExgGXE_Vw"
                                    >
                                      {" "}
                                      How to create a Metamask Wallet to buy
                                      MRMINT.
                                    </a>{" "}
                                    <br />
                                    If you prefer Trust Wallet, follow this -{" "}
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="images/trustwalletprocess.pdf"
                                    >
                                      {" "}
                                      How to create a Trust Wallet to buy MRMINT{" "}
                                    </a>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="7" className="mb-3">
                                <Accordion.Header>
                                  How does the $MRMINT Wallet Interface work?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p>
                                    Once you connect your Metamask to access
                                    your $MRMINT Wallet Interface, you get several
                                    options that show you your $MRMINT holdings,
                                    staking, and referral earning data.
                                  </p>

                                  <p>
                                    Staking Rewards: You earn $MRMINT against
                                    staked MRMINT depending on the number of months
                                    you have staked for.
                                  </p>

                                  <p>
                                    Referral Rewards: You earn $MRMINT worth 5% of
                                    the deposit amount of all users using your
                                    unique referral ID.
                                  </p>

                                  <p className="mb-0">
                                    Withdraw button: All staking rewards and
                                    referral rewards can be withdrawn via this
                                    button. Staking rewards can be withdrawn on
                                    a monthly basis. Withdrawals can be made to
                                    the connected metamask wallet.
                                  </p>
                                  <p>
                                    For a detailed explanation you may watch
                                    this guide:{" "}
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://www.youtube.com/watch?v=FrHaUd0rXog"
                                    >
                                      {" "}
                                      Guide on the Wallet Interface
                                    </a>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="8" className="mb-3">
                                <Accordion.Header>
                                  I have purchased $MRMINT but don't know how to
                                  stake? How does $MRMINT Staking work?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    When you visit Mr Mint.io and connect your
                                    wallet, you get to see how many $MRMINT you
                                    currently hold. These tokens remain vested
                                    for 9 months from the date of purchase. But
                                    you have the opportunity to stake them and
                                    earn from staking during the vesting period.
                                    To know how to stake your MRMINT refer this
                                    guide: <br />
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://www.youtube.com/watch?v=FrHaUd0rXog"
                                    >
                                      Here’s a guide on the Wallet Interface and
                                      how you can stake MRMINT
                                    </a>
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="9" className="mb-3">
                                <Accordion.Header>
                                  When can I withdraw my Staking Rewards?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    Staking rewards will reflect in your staking
                                    earnings on a monthly basis. They can be
                                    withdrawn on a monthly basis too. Staking
                                    rewards cannot be vested, but they can be
                                    traded immediately.
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="10" className="mb-3">
                                <Accordion.Header>
                                  Why can’t I trade $MRMINT soon after I buy? Why
                                  are my tokens locked and what is the vesting
                                  period?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    When you buy $MRMINT, your tokens are locked
                                    for a period of 9 months from the date of
                                    purchase. We do this to protect investors
                                    from price fluctuations or what is largely
                                    known as ‘pump and dump’ in the crypto
                                    world. Waiting for a predetermined duration
                                    means that the token will have stability in
                                    price, and early investors can use our
                                    staking mechanism to benefit and receive
                                    rewards.
                                  </p>

                                  <p>
                                    You can refer to the table below that
                                    explains the vesting schedule:
                                  </p>
                                  <div style={{ overflowX: "auto" }}>
                                    <table
                                      className="table text-center border border-dark"
                                      width="100%"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Phase</th>
                                          <th>Token Price</th>
                                          <th>Vesting Details</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>Private Sale</td>
                                          <td>$0.054</td>
                                          <td>
                                            5% unlock every month, after 9
                                            months of purchase
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Pre Sale</td>
                                          <td>$0.094</td>
                                          <td>
                                            8% unlock every month, after 9
                                            months of purchase
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Public Sale</td>
                                          <td>$0.15</td>
                                          <td>
                                            10% unlock every month, after 9
                                            months of purchase
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <p></p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="11" className="mb-3">
                                <Accordion.Header>
                                  Something is not working for me. Where can I
                                  contact the Mr Mint team?
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    We are happy to help you. In case you need
                                    anything, Don’t hesitate to contact us here:
                                    <a
                                      target="_blank"
                                      style={{ color: "#11c2ff" }}
                                      href="https://mrmint.io/contact-us"
                                    >
                                      {" "}
                                      https://mrmint.io/contact-us{" "}
                                    </a>
                                    Or DM us on any of our social media
                                    accounts.
                                  </p>
                                  <p>
                                    Also note that the Mr Mint team will never
                                    contact you directly or ask for any of your
                                    information.
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                            <Col lg={6}>
                              <Accordion.Item eventKey="12" className="mb-3">
                                <Accordion.Header>
                                  Someone is messaging me about $MRMINT and asking
                                  for my keys, wallets, funds or seed phrase.
                                </Accordion.Header>
                                <Accordion.Body>
                                  <p className="mb-0">
                                    Never give anyone your Wallet Keys or insert
                                    them into any links on the internet. The
                                    $MRMINT team will never ask you for any of this
                                    information. Beware of scammers and anyone
                                    that seems suspicious. Always ask in the
                                    public chat and wait for a response from an
                                    official admin or team member if you are
                                    uncertain.
                                  </p>
                                  <p></p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Col>
                          </Row>
                        </Accordion>
                      </div>
                    </Slide>
                  </Col>
                </Row>
              </Container>
            </Container>
          </section>
          <Footer />
        </section>
      </main>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        className='connact_wallet'
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="notice_popup">
            <h3 className="mb-4 text-center">🚨 IMPORTANT ANNOUNCEMENT: Trading Pause & Blockchain Migration Update</h3>

            <p>Dear MrMint Community,</p>

            <p>
              We are writing to inform you about an important update regarding MrMint token trading and our upcoming blockchain migration.
            </p>

            <h4 className="mt-4">Trading Pause Notice:</h4>
            <p>
              Effective immediately, we are temporarily pausing all trading activities on Centralized Exchanges (CEX) and Decentralized Exchanges (DEX)
              due to our ongoing migration to a new blockchain network. This strategic move will enhance our token's performance, security, and utility.
            </p>

            <h4 className="mt-4">Interim Trading Solution:</h4>
            <p>
              To ensure our community maintains access to liquidity for buying and selling MRMINT during this transition period, we are proud to launch our
              dedicated P2P (Peer-to-Peer) trading platform:<br />
              <a href="https://www.mrmint.exchange" target="_blank" rel="noopener noreferrer" style={{ color: '#4c93ff' }}>
                www.mrmint.exchange
              </a>
            </p>

            <h4 className="mt-4">Fair Launch Pricing:</h4>
            <p>
              The token will be available on our P2P platform at <strong>$0.1565</strong> - the 24-hour high price - to ensure fairness and keep the
              community protected during this migration period.
            </p>

            <h4 className="mt-4">Getting Started:</h4>
            <p>
              Please refer to the video tutorial and follow step-by-step guide to Start trading MRMINT safely during the migration:
            </p>

            <p>
              We appreciate your patience and continued support as we work to improve the MrMint ecosystem. This migration will position us for greater growth
              and enhanced functionality.
            </p>

            <p><strong>Thank you for being part of the MrMint journey!</strong></p>

            <p className="mt-2">
              <strong>Important Reminder:</strong> Please ensure you only use the official P2P platform link provided above and follow the official guides for
              your safety and security during this transition period.
            </p>

            <div className="text-end mt-4">
              <a href={`${config.baseUrl}notice`} style={{ color: '#4c93ff' }}>Read More</a>
            </div>
          </div>

        </Modal.Body>
        {/* <Modal.Footer>
          
        </Modal.Footer> */}
      </Modal>
    </>
  );
};
export default Home;
